/* gt-lead-events.js — GT B2B Meta lead bridge (browser side).
 *
 * Publishes internal Shopify custom events ("gt:lead") that a Shopify
 * Custom Pixel (Settings -> Customer events) subscribes to and forwards to
 * Meta. NO Meta pixel / fbq / base script lives here or anywhere in the
 * theme: the theme only PUBLISHES; the Meta network call happens inside the
 * consent-gated Web Pixels sandbox. See META-TRACKING-AUDIT.md.
 *
 * Fully fail-open: every path is wrapped so a missing/rejected analytics API
 * can never throw, block navigation, or delay the dialer / WhatsApp hand-off.
 */
(function () {
  if (window.__gtLeadEvents) return;
  window.__gtLeadEvents = true;

  /* Publish one "gt:lead" event. Fire-and-forget, never awaited, never throws.
     leadType: 'whatsapp_order' | 'phone_click'. extra: optional light context. */
  function gtEmitLead(leadType, extra) {
    try {
      if (!leadType) return;
      if (
        typeof Shopify === 'undefined' ||
        !Shopify.analytics ||
        typeof Shopify.analytics.publish !== 'function'
      ) {
        return; // analytics not present -> silently no-op (storefront unaffected)
      }
      var data = { lead_type: leadType };
      if (extra && typeof extra === 'object') {
        for (var k in extra) {
          if (Object.prototype.hasOwnProperty.call(extra, k)) data[k] = extra[k];
        }
      }
      Shopify.analytics.publish('gt:lead', data);
    } catch (e) {
      /* swallow — analytics must never affect the storefront */
    }
  }

  window.gtEmitLead = gtEmitLead;

  /* Delegated listener for real tel: anchors only (never plain phone text).
     Passive: does NOT preventDefault, so the dialer opens with zero delay. */
  document.addEventListener(
    'click',
    function (e) {
      try {
        var target = e.target && e.target.closest ? e.target.closest('a[href^="tel:"]') : null;
        if (!target) return;
        var href = target.getAttribute('href') || '';
        var digits = href.replace(/^tel:/i, '').replace(/[^0-9]/g, '');
        gtEmitLead('phone_click', { number: digits, href: href });
      } catch (err) {
        /* swallow */
      }
    },
    true // capture: still fires even if a nested handler stops propagation
  );
})();
